/* @ngInject */
const newMovement = (

) => {
  const self = {}

  self.classic = () => {
    return {
      areaId: null,
      railawyId: null,
      dateBegin: null,
      dateEnd: null,
      date: null,
      wagonId: null,
    }
  }

  self.search = () => {
    return {
      areaId: null,
      railawyId: null,
      dateBegin: null,
      dateEnd: null,
      date: null,
      wagonId: null,
      park: true,
      unpark: true,
      move: true,
    }
  }

  return self
}

export default newMovement



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/new.service.js